import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';
import { HttpVerificationService } from '../../../../../service/http-verification.service';
import { LiveStatusEnum } from '../../../../../service/dto';


@Component({
	selector: 'app-dynamic-form-input-id-number-of-deceased-person',
	standalone: false,
	templateUrl: './dynamic-form-input-id-number-of-deceased-person.component.html',
	styleUrl: './dynamic-form-input-id-number-of-deceased-person.component.scss'
})
export class DynamicFormInputIdNumberOfDeceasedPersonComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;

	verificationStatus: LiveStatusEnum = 'Unverified';
	isVerifying = false;

	constructor(private httpService: HttpVerificationService) { }

	get controlKey(): string {
		return this.toControlKey(this.wrapper.element);
	}

	get idNumberValue(): string {
		return this.form.get(this.controlKey)?.value ?? '';
	}

	verify(): void {
		const idNumber = this.idNumberValue;
		if (!idNumber || this.isVerifying) return;

		this.isVerifying = true;
		this.verificationStatus = 'Unverified';

		// Reset any existing deceased error before re-verifying
		const control = this.form.get(this.controlKey);
		if (control) {
			const { alive, ...otherErrors } = control.errors ?? {};
			control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
		}

		this.httpService.getLiveStatusById(idNumber)
			.subscribe({
				next: (response) => {
					this.verificationStatus = response;
					if (response === 'Living') {
						control?.setErrors({ ...(control.errors ?? {}), alive: true });
					}
					this.isVerifying = false;
				},
				error: () => {
					this.verificationStatus = 'Error';
					this.isVerifying = false;
				}
			});
	}
}
